export const deleteChoice = `mutation($model : DeleteChoiceRequest!){
    deleteChoice(input : $model) 
  }`
